<template>
  <div class="body-div">
    <div class="main-nav styleCard">
      <ul class="style-nav style1">
        <li
          v-for="tab in repTabs"
          :key="tab.id"
          class="router-link"
          @click="selectedRepTab = tab.alias"
          :class="{ active: selectedRepTab === tab.alias }"
        >
          {{ tab.name }}
        </li>
      </ul>
    </div>
    <div class="main-nav styleCard">
      <ul class="style-nav style1">
        <li
          v-for="tab in secRepTabs"
          :key="tab.id"
          class="router-link"
          @click="selectedSecRepTab = tab.alias"
          :class="{ active: selectedSecRepTab === tab.alias }"
        >
          {{ tab.name }}
        </li>
      </ul>
    </div>
    <div class="top-div">
      <!--      <div class="table" v-if="selectedRepTab === 'TODAY'">-->
      <!--        <table>-->
      <!--          <thead>-->
      <!--            <tr>-->
      <!--              <th>-->
      <!--                DEP ID-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Agent-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Broker-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Status-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Amount-->
      <!--              </th>-->

      <!--              <th>-->
      <!--                Method-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Comment-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Created at-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Updated at-->
      <!--              </th>-->

      <!--              <th>-->
      <!--                Removed Comment-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Removed at-->
      <!--              </th>-->
      <!--            </tr>-->
      <!--          </thead>-->
      <!--          <tbody>-->
      <!--            <tr v-for="dep in depositExtendedReports.today" :key="dep.id">-->
      <!--              <td>#{{ dep.id }}</td>-->
      <!--              <td>{{ dep.user.full_name }}</td>-->
      <!--              <td>{{ dep.campaign.name }}</td>-->
      <!--              <td>{{ dep.type.type }}</td>-->

      <!--              <td>-->
      <!--                {{ dep.amount }}-->
      <!--                <span v-if="dep.currency_id !== null">{{-->
      <!--                  dep.currency.name-->
      <!--                }}</span>-->
      <!--              </td>-->
      <!--              <td>-->
      <!--                <span v-if="dep.method_id !== null">{{-->
      <!--                  dep.method.method-->
      <!--                }}</span>-->
      <!--              </td>-->
      <!--              <td>{{ dep.comment }}</td>-->
      <!--              <td>{{ formatDate(dep.created_at) }}</td>-->
      <!--              <td>{{ formatDate(dep.updated_at) }}</td>-->

      <!--              <td>{{ dep.rem_stat_comment }}</td>-->
      <!--              <td>-->
      <!--                <span-->
      <!--                  v-if="-->
      <!--                    findStatusChangeByDepID('today_status_changes', dep.id) !==-->
      <!--                      undefined-->
      <!--                  "-->
      <!--                  >{{-->
      <!--                    findStatusChangeByDepID("today_status_changes", dep.id)-->
      <!--                      .changed_status_at-->
      <!--                  }}</span-->
      <!--                >-->
      <!--              </td>-->
      <!--            </tr>-->
      <!--          </tbody>-->
      <!--        </table>-->
      <!--      </div>-->

      <!--      <div class="table" v-if="selectedRepTab === 'YESTERDAY'">-->
      <!--        <table>-->
      <!--          <thead>-->
      <!--            <tr>-->
      <!--              <th>-->
      <!--                DEP ID-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Agent-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Broker-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Status-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Amount-->
      <!--              </th>-->

      <!--              <th>-->
      <!--                Method-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Comment-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Created at-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Updated at-->
      <!--              </th>-->

      <!--              <th>-->
      <!--                Removed Comment-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Removed at-->
      <!--              </th>-->
      <!--            </tr>-->
      <!--          </thead>-->
      <!--          <tbody>-->
      <!--            <tr v-for="dep in depositExtendedReports.yesterday" :key="dep.id">-->
      <!--              <td>#{{ dep.id }}</td>-->
      <!--              <td>{{ dep.user.full_name }}</td>-->
      <!--              <td>{{ dep.campaign.name }}</td>-->
      <!--              <td>{{ dep.type.type }}</td>-->

      <!--              <td>-->
      <!--                {{ dep.amount }}-->
      <!--                <span v-if="dep.currency_id !== null">{{-->
      <!--                  dep.currency.name-->
      <!--                }}</span>-->
      <!--              </td>-->
      <!--              <td>-->
      <!--                <span v-if="dep.method_id !== null">{{-->
      <!--                  dep.method.method-->
      <!--                }}</span>-->
      <!--              </td>-->
      <!--              <td>{{ dep.comment }}</td>-->
      <!--              <td>{{ formatDate(dep.created_at) }}</td>-->
      <!--              <td>{{ formatDate(dep.updated_at) }}</td>-->

      <!--              <td>{{ dep.rem_stat_comment }}</td>-->
      <!--              <td>-->
      <!--                <span-->
      <!--                  v-if="-->
      <!--                    findStatusChangeByDepID(-->
      <!--                      'yesterday_status_changes',-->
      <!--                      dep.id-->
      <!--                    ) !== undefined-->
      <!--                  "-->
      <!--                  >{{-->
      <!--                    findStatusChangeByDepID("yesterday_status_changes", dep.id)-->
      <!--                      .changed_status_at-->
      <!--                  }}</span-->
      <!--                >-->
      <!--              </td>-->
      <!--            </tr>-->
      <!--          </tbody>-->
      <!--        </table>-->
      <!--      </div>-->

      <!--      <div class="table" v-if="selectedRepTab === 'THIS_MONTH'">-->
      <!--        <table>-->
      <!--          <thead>-->
      <!--            <tr>-->
      <!--              <th>-->
      <!--                DEP ID-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Agent-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Broker-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Status-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Amount-->
      <!--              </th>-->

      <!--              <th>-->
      <!--                Method-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Comment-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Created at-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Updated at-->
      <!--              </th>-->

      <!--              <th>-->
      <!--                Removed Comment-->
      <!--              </th>-->
      <!--              <th>-->
      <!--                Removed at-->
      <!--              </th>-->
      <!--            </tr>-->
      <!--          </thead>-->
      <!--          <tbody>-->
      <!--            <tr v-for="dep in depositExtendedReports.this_month" :key="dep.id">-->
      <!--              <td>#{{ dep.id }}</td>-->
      <!--              <td>{{ dep.user.full_name }}</td>-->
      <!--              <td>{{ dep.campaign.name }}</td>-->
      <!--              <td>{{ dep.type.type }}</td>-->

      <!--              <td>-->
      <!--                {{ dep.amount }}-->
      <!--                <span v-if="dep.currency_id !== null">{{-->
      <!--                  dep.currency.name-->
      <!--                }}</span>-->
      <!--              </td>-->
      <!--              <td>-->
      <!--                <span v-if="dep.method_id !== null">{{-->
      <!--                  dep.method.method-->
      <!--                }}</span>-->
      <!--              </td>-->
      <!--              <td>{{ dep.comment }}</td>-->
      <!--              <td>{{ formatDate(dep.created_at) }}</td>-->
      <!--              <td>{{ formatDate(dep.updated_at) }}</td>-->

      <!--              <td>{{ dep.rem_stat_comment }}</td>-->
      <!--              <td>-->
      <!--                <span-->
      <!--                  v-if="-->
      <!--                    findStatusChangeByDepID(-->
      <!--                      'this_month_status_changes',-->
      <!--                      dep.id-->
      <!--                    ) !== undefined-->
      <!--                  "-->
      <!--                  >{{-->
      <!--                    findStatusChangeByDepID("this_month_status_changes", dep.id)-->
      <!--                      .changed_status_at-->
      <!--                  }}</span-->
      <!--                >-->
      <!--              </td>-->
      <!--            </tr>-->
      <!--          </tbody>-->
      <!--        </table>-->
      <!--      </div>-->
      <div
        class="table"
        v-if="selectedRepTab === 'TODAY' && selectedSecRepTab === 'NORMAL'"
      >
        <table>
          <thead>
            <tr>
              <th>
                DEP ID
              </th>
              <th>
                Agent
              </th>
              <th>
                Broker
              </th>
              <th>
                Status
              </th>
              <th>
                Amount
              </th>

              <th>
                Method
              </th>
              <th>
                Comment
              </th>
              <th>
                Created at
              </th>
              <th>
                Updated at
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="dep in depositExtendedReports.today" :key="dep.id">
              <td>#{{ dep.id }}</td>
              <td>{{ dep.user.full_name }}</td>
              <td>{{ dep.campaign.name }}</td>
              <td>{{ dep.type.type }}</td>

              <td>
                {{ dep.amount }}
                <span v-if="dep.currency_id !== null">{{
                  dep.currency.name
                }}</span>
              </td>
              <td>
                <span v-if="dep.method_id !== null">{{
                  dep.method.method
                }}</span>
              </td>
              <td>{{ dep.comment }}</td>
              <td>{{ formatDate(dep.created_at) }}</td>
              <td>{{ formatDate(dep.updated_at) }}</td>

              <!--              <td>{{ dep.rem_stat_comment }}</td>-->
              <!--              <td>-->
              <!--                <span-->
              <!--                  v-if="-->
              <!--                    findStatusChangeByDepID(-->
              <!--                      'last_month_status_changes',-->
              <!--                      dep.id-->
              <!--                    ) !== undefined-->
              <!--                  "-->
              <!--                  >{{-->
              <!--                    findStatusChangeByDepID("last_month_status_changes", dep.id)-->
              <!--                      .changed_status_at-->
              <!--                  }}</span-->
              <!--                >-->
              <!--              </td>-->
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="table"
        v-if="selectedRepTab === 'TODAY' && selectedSecRepTab === 'REMOVED'"
      >
        <table>
          <thead>
            <tr>
              <th>
                DEP ID
              </th>
              <th>
                Agent
              </th>
              <th>
                Broker
              </th>
              <th>
                Deposited at
              </th>
              <th>
                Reason
              </th>
              <th>
                Removed at
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="dep in filterRemovedDeposits(depositExtendedReports.today)"
              :key="dep.id"
            >
              <td>#{{ dep.id }}</td>
              <td>{{ dep.user.full_name }}</td>
              <td>{{ dep.campaign.name }}</td>

              <td>{{ formatDate(dep.created_at) }}</td>
              <td>{{ dep.rem_stat_comment }}</td>
              <td>
                <!--                <span-->
                <!--                        v-if="-->
                <!--                    findStatusChangeByDepID(-->
                <!--                      'last_month_status_changes',-->
                <!--                      dep.id-->
                <!--                    ) !== undefined-->
                <!--                  "-->
                <!--                ><{{-->
                <!--                    findStatusChangeByDepID("last_month_status_changes", dep.id)-->
                <!--                      .changed_status_at-->
                <!--                  }}-->
                <!--                -->
                <!--                </span-->
                <!--                >-->
                {{ formatDate(dep.updated_at) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="table"
        v-if="selectedRepTab === 'YESTERDAY' && selectedSecRepTab === 'NORMAL'"
      >
        <table>
          <thead>
            <tr>
              <th>
                DEP ID
              </th>
              <th>
                Agent
              </th>
              <th>
                Broker
              </th>
              <th>
                Status
              </th>
              <th>
                Amount
              </th>

              <th>
                Method
              </th>
              <th>
                Comment
              </th>
              <th>
                Created at
              </th>
              <th>
                Updated at
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="dep in depositExtendedReports.yesterday" :key="dep.id">
              <td>#{{ dep.id }}</td>
              <td>{{ dep.user.full_name }}</td>
              <td>{{ dep.campaign.name }}</td>
              <td>{{ dep.type.type }}</td>

              <td>
                {{ dep.amount }}
                <span v-if="dep.currency_id !== null">{{
                  dep.currency.name
                }}</span>
              </td>
              <td>
                <span v-if="dep.method_id !== null">{{
                  dep.method.method
                }}</span>
              </td>
              <td>{{ dep.comment }}</td>
              <td>{{ formatDate(dep.created_at) }}</td>
              <td>{{ formatDate(dep.updated_at) }}</td>

              <!--              <td>{{ dep.rem_stat_comment }}</td>-->
              <!--              <td>-->
              <!--                <span-->
              <!--                  v-if="-->
              <!--                    findStatusChangeByDepID(-->
              <!--                      'last_month_status_changes',-->
              <!--                      dep.id-->
              <!--                    ) !== undefined-->
              <!--                  "-->
              <!--                  >{{-->
              <!--                    findStatusChangeByDepID("last_month_status_changes", dep.id)-->
              <!--                      .changed_status_at-->
              <!--                  }}</span-->
              <!--                >-->
              <!--              </td>-->
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="table"
        v-if="selectedRepTab === 'YESTERDAY' && selectedSecRepTab === 'REMOVED'"
      >
        <table>
          <thead>
            <tr>
              <th>
                DEP ID
              </th>
              <th>
                Agent
              </th>
              <th>
                Broker
              </th>
              <th>
                Deposited at
              </th>
              <th>
                Reason
              </th>
              <th>
                Removed at
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="dep in filterRemovedDeposits(
                depositExtendedReports.yesterday
              )"
              :key="dep.id"
            >
              <td>#{{ dep.id }}</td>
              <td>{{ dep.user.full_name }}</td>
              <td>{{ dep.campaign.name }}</td>

              <td>{{ formatDate(dep.created_at) }}</td>
              <td>{{ dep.rem_stat_comment }}</td>
              <td>
                <!--                <span-->
                <!--                        v-if="-->
                <!--                    findStatusChangeByDepID(-->
                <!--                      'last_month_status_changes',-->
                <!--                      dep.id-->
                <!--                    ) !== undefined-->
                <!--                  "-->
                <!--                ><{{-->
                <!--                    findStatusChangeByDepID("last_month_status_changes", dep.id)-->
                <!--                      .changed_status_at-->
                <!--                  }}-->
                <!--                -->
                <!--                </span-->
                <!--                >-->
                {{ formatDate(dep.updated_at) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="table"
        v-if="selectedRepTab === 'THIS_MONTH' && selectedSecRepTab === 'NORMAL'"
      >
        <table>
          <thead>
            <tr>
              <th>
                DEP ID
              </th>
              <th>
                Agent
              </th>
              <th>
                Broker
              </th>
              <th>
                Status
              </th>
              <th>
                Amount
              </th>

              <th>
                Method
              </th>
              <th>
                Comment
              </th>
              <th>
                Created at
              </th>
              <th>
                Updated at
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="dep in depositExtendedReports.this_month" :key="dep.id">
              <td>#{{ dep.id }}</td>
              <td>{{ dep.user.full_name }}</td>
              <td>{{ dep.campaign.name }}</td>
              <td>{{ dep.type.type }}</td>

              <td>
                {{ dep.amount }}
                <span v-if="dep.currency_id !== null">{{
                  dep.currency.name
                }}</span>
              </td>
              <td>
                <span v-if="dep.method_id !== null">{{
                  dep.method.method
                }}</span>
              </td>
              <td>{{ dep.comment }}</td>
              <td>{{ formatDate(dep.created_at) }}</td>
              <td>{{ formatDate(dep.updated_at) }}</td>

              <!--              <td>{{ dep.rem_stat_comment }}</td>-->
              <!--              <td>-->
              <!--                <span-->
              <!--                  v-if="-->
              <!--                    findStatusChangeByDepID(-->
              <!--                      'last_month_status_changes',-->
              <!--                      dep.id-->
              <!--                    ) !== undefined-->
              <!--                  "-->
              <!--                  >{{-->
              <!--                    findStatusChangeByDepID("last_month_status_changes", dep.id)-->
              <!--                      .changed_status_at-->
              <!--                  }}</span-->
              <!--                >-->
              <!--              </td>-->
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="table"
        v-if="
          selectedRepTab === 'THIS_MONTH' && selectedSecRepTab === 'REMOVED'
        "
      >
        <table>
          <thead>
            <tr>
              <th>
                DEP ID
              </th>
              <th>
                Agent
              </th>
              <th>
                Broker
              </th>
              <th>
                Deposited at
              </th>
              <th>
                Reason
              </th>
              <th>
                Removed at
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="dep in filterRemovedDeposits(
                depositExtendedReports.this_month
              )"
              :key="dep.id"
            >
              <td>#{{ dep.id }}</td>
              <td>{{ dep.user.full_name }}</td>
              <td>{{ dep.campaign.name }}</td>

              <td>{{ formatDate(dep.created_at) }}</td>
              <td>{{ dep.rem_stat_comment }}</td>
              <td>
                <!--                <span-->
                <!--                        v-if="-->
                <!--                    findStatusChangeByDepID(-->
                <!--                      'last_month_status_changes',-->
                <!--                      dep.id-->
                <!--                    ) !== undefined-->
                <!--                  "-->
                <!--                ><{{-->
                <!--                    findStatusChangeByDepID("last_month_status_changes", dep.id)-->
                <!--                      .changed_status_at-->
                <!--                  }}-->
                <!--                -->
                <!--                </span-->
                <!--                >-->
                {{ formatDate(dep.updated_at) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="table"
        v-if="selectedRepTab === 'LAST_MONTH' && selectedSecRepTab === 'NORMAL'"
      >
        <table>
          <thead>
            <tr>
              <th>
                DEP ID
              </th>
              <th>
                Agent
              </th>
              <th>
                Broker
              </th>
              <th>
                Status
              </th>
              <th>
                Amount
              </th>

              <th>
                Method
              </th>
              <th>
                Comment
              </th>
              <th>
                Created at
              </th>
              <th>
                Updated at
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="dep in depositExtendedReports.last_month" :key="dep.id">
              <td>#{{ dep.id }}</td>
              <td>{{ dep.user.full_name }}</td>
              <td>{{ dep.campaign.name }}</td>
              <td>{{ dep.type.type }}</td>

              <td>
                {{ dep.amount }}
                <span v-if="dep.currency_id !== null">{{
                  dep.currency.name
                }}</span>
              </td>
              <td>
                <span v-if="dep.method_id !== null">{{
                  dep.method.method
                }}</span>
              </td>
              <td>{{ dep.comment }}</td>
              <td>{{ formatDate(dep.created_at) }}</td>
              <td>{{ formatDate(dep.updated_at) }}</td>

              <!--              <td>{{ dep.rem_stat_comment }}</td>-->
              <!--              <td>-->
              <!--                <span-->
              <!--                  v-if="-->
              <!--                    findStatusChangeByDepID(-->
              <!--                      'last_month_status_changes',-->
              <!--                      dep.id-->
              <!--                    ) !== undefined-->
              <!--                  "-->
              <!--                  >{{-->
              <!--                    findStatusChangeByDepID("last_month_status_changes", dep.id)-->
              <!--                      .changed_status_at-->
              <!--                  }}</span-->
              <!--                >-->
              <!--              </td>-->
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="table"
        v-if="
          selectedRepTab === 'LAST_MONTH' && selectedSecRepTab === 'REMOVED'
        "
      >
        <table>
          <thead>
            <tr>
              <th>
                DEP ID
              </th>
              <th>
                Agent
              </th>
              <th>
                Broker
              </th>
              <th>
                Deposited at
              </th>
              <th>
                Reason
              </th>
              <th>
                Removed at
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="dep in filterRemovedDeposits(
                depositExtendedReports.last_month
              )"
              :key="dep.id"
            >
              <td>#{{ dep.id }}</td>
              <td>{{ dep.user.full_name }}</td>
              <td>{{ dep.campaign.name }}</td>

              <td>{{ formatDate(dep.created_at) }}</td>
              <td>{{ dep.rem_stat_comment }}</td>
              <td>
                <!--                <span-->
                <!--                        v-if="-->
                <!--                    findStatusChangeByDepID(-->
                <!--                      'last_month_status_changes',-->
                <!--                      dep.id-->
                <!--                    ) !== undefined-->
                <!--                  "-->
                <!--                ><{{-->
                <!--                    findStatusChangeByDepID("last_month_status_changes", dep.id)-->
                <!--                      .changed_status_at-->
                <!--                  }}-->
                <!--                -->
                <!--                </span-->
                <!--                >-->
                {{ formatDate(dep.updated_at) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <loader
        class="loader"
        :size="'8px'"
        v-if="requestDepositsReportBusy"
      ></loader>
    </div>
  </div>
</template>

<script>
import Loader from "../../../../../main/misc.main/loader/Loader";
import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
import UsersPermissionCheck from "../../../../../mixins/user/auth/UsersPermissionCheck";
import moment from "moment";

export default {
  name: "NotInterested.container",
  components: { Loader },
  mixins: [UsersPermissionCheck],
  data() {
    return {
      requestDepositsReportBusy: false,
      depositExtendedReports: {},
      repTabs: [
        {
          id: 0,
          name: "TODAY",
          alias: "TODAY"
        },
        {
          id: 1,
          name: "YESTERDAY",
          alias: "YESTERDAY"
        },
        {
          id: 2,
          name: "THIS MONTH",
          alias: "THIS_MONTH"
        },
        {
          id: 3,
          name: "LAST MONTH",
          alias: "LAST_MONTH"
        }
      ],
      secRepTabs: [
        {
          id: 0,
          name: "NORMAL",
          alias: "NORMAL"
        },
        {
          id: 1,
          name: "REMOVED",
          alias: "REMOVED"
        }
      ],

      selectedRepTab: "THIS_MONTH",
      selectedSecRepTab: "NORMAL"
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"])
  },
  created() {
    this.getDepositsExtendedReports();
  },
  methods: {
    filterRemovedDeposits(arr) {
      return arr.filter(dep => dep.status_id === 4);
    },
    findStatusChangeByDepID(conStatusTimeFrame, depId) {
      // console.log(
      //   this.depositExtendedReports[conStatusTimeFrame].find(
      //     status => status.deposit_id === depId
      //   )
      // );
      return this.depositExtendedReports[conStatusTimeFrame].find(
        status => status.deposit_id === depId
      );
    },

    formatDate(date) {
      return moment(String(date)).format("HH:mm DD/MM/YY ");
    },
    getDepositsExtendedReports() {
      if (
        !this.requestDepositsReportBusy &&
        this.CheckUserPermission([1, 2, 3, 4, 12])
      ) {
        this.requestDepositsReportBusy = true;
        apiClientCreator(`reports/deposits/extended`)
          .get("")
          .then(res => {
            this.depositExtendedReports = res.data;

            this.requestDepositsReportBusy = false;
          })
          .catch(err => {
            this.requestDepositsReportBusy = false;
          });
      }
    }
  }
};
</script>

<style scoped>
.body-div {
  padding: 4px 5px 1px 5px;
}
.top-div {
  width: 100%;
  height: max-content;
  margin: auto;
  background: white;
  border-radius: 3px;
  min-height: 300px;
  padding: 5px;
}
.bottom-div {
  width: 100%;
  height: 284px;
  margin: 5px auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
}
.fab {
  background-color: transparent;
  padding: 0;
  font-size: 30px;
  line-height: 30px;
  color: green;
  text-align: center;
  position: absolute;
  right: 10px;
  bottom: 10px;
  border-radius: 20%;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}

.fab:hover {
  box-shadow: 0 5px 11px 0 #666;
  transform: scale(1.05);
}
.table {
  /* float: left;*/
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 10px;
}
.table table {
  font-size: 13px;
  width: 100%;
  /*   margin-right: auto;*/
  margin-left: 7px;
  margin-right: 7px;
}
/*.ca-auto-status-override{
          width: 355px !important;
        }
        .ca-regular-status-override{
          width: 450px !important;
        }*/
.table thead {
  border-bottom: solid 2px #eff3f6;
}
.table th {
  text-align: left;
  font-size: 12px;
}
.table .td-count {
  text-align: center;
}
.table td {
  border-bottom: solid 2px #eff3f6;
}
.text-center {
  font-weight: bold;
}

.paginationContainer {
  /*margin-left: 10px;*/
  font-size: 15px;
  width: 110px;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
.page-btn {
  background: white;
}

.page-num {
  cursor: inherit;
}
.loader {
  position: absolute;
  top: 100px;

  left: 0;
  right: 0;
}
.flat-bottom-div {
  margin-top: 10px;
  height: 40px;
  width: 100%;
}
.tr-main-cat {
  background: #44a2d2;
  color: white;
  padding: 1px;
  width: 100%;
}
.style-nav .router-link {
  max-width: 150px;
  min-width: 72px;
  height: 28px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 11px;
  color: black;
  text-align: center;
  vertical-align: middle;
  line-height: 28px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.3s ease, color 0.3s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 .router-link:not(.empty):hover {
  background: #44a2d2;
  color: white;
  text-decoration: none;
}

.style-nav.style1 .router-link.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
  text-decoration: none;
}
.main-nav {
  display: flex;
  flex-direction: column;
  border-radius: 0;
  background: white;
  margin-top: 0.3rem !important;
  border-bottom: solid 2px #eff3f6;
}
.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
}
</style>
